export default __webpack_public_path__ + "static/media/blogpost4.f5e55499.jpg";